import EANDetail from './EANDetail';

export default {
    EANDetail,
};
